// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_jx-0";
export var buttonContainer = "_jx-3";
export var cancelButton = "_jx-4";
export var headerSection = "_jx-6";
export var headerTitle = "_jx-9";
export var messageSideLeft = "_jx-1";
export var messageSideRight = "_jx-2";
export var orderNumberContainer = "_jx-7";
export var orderNumberLabel = "_jx-8";
export var submitButton = "_jx-5";